import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { setImgsize, loadScript } from '@/utils/utils';
import flexible from '../../../utils/flexible.js';
import audioItemv2 from './components/audioItem';
import guideBottom from '@/components/guideBottom.vue';
import guideTheme from '@/components/guideTheme.vue';
import bigImg from '@/components/bigImg.vue';
import { ImagePreview } from 'vant';
import hysbwg from '@/components/hysbwg.vue';
export default {
  name: 'audiosv2',
  data() {
    return {
      bannersList: [],
      detail: {},
      //展览详情
      formData: {},
      exhibCode: '',
      isFolded: true,
      audioList: [],
      exhibName: '',
      language: '',
      recordList: [],
      descflag: false,
      loading: false,
      finished: false,
      page: 1,
      total: 0,
      timer: null,
      descTimer: null,
      bigImgs: [],
      audioType: 1
    };
  },
  components: {
    audioItemv2,
    guideBottom,
    guideTheme,
    hysbwg
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  methods: {
    showBigImg() {
      ImagePreview({
        images: [this.detail.images.fileUrl],
        // startPosition: 1,
        onClose() {
          // do something
        }
      });
    },
    getType(type) {
      return type == '常设展览' ? 'permanent' : 'temporary';
    },
    getIdDetail() {
      let searchStr = {
        filters: [[{
          alias: '10',
          compt: "autonumber",
          express: '===',
          id: 10,
          range: null,
          val: this.exhibCode
        }]],
        model: 0
      };
      let data = {
        page: 1,
        limit: 100,
        deptId: this.formData.fid,
        formId: this.formData.exhibition_formId,
        searchStr: encodeURI(JSON.stringify(searchStr))
      };
      this.$api.singleadvanceSearch(data).then(res => {
        let list = this.setDatas(res.dataList, 'banner');
        this.detail = list[0];
        this.bigImgs = [this.detail.images.fileUrl];
        console.log(this.detail, 'detail');
        if (!this.detail.exhibName) return;
        document.title = this.detail.exhibName;
        this.exhibName = this.detail.exhibName;
        this.getAudioList();
        /* MultiEditor存在 */
        this.timer = setInterval(() => {
          if (MultiEditor !== undefined) {
            clearInterval(this.timer);
            MultiEditor.init('detail', null, {
              attachMode: 'preview',
              largePreview: 'largePreview'
            });
            MultiEditor.renderRichtext('editor1', this.language ? this.detail.en_desc : this.detail.description);
          }
        }, 500);
        if ((this.language ? this.detail.en_desc : this.detail.description) === '') return;
        /* introduction有值 */
        this.descTimer = setInterval(() => {
          if (document.querySelector('#desc').innerText !== '') {
            clearInterval(this.descTimer);
            let desclen = document.querySelector('#desc').innerText.length;
            if (desclen > 100) this.descflag = true;
          }
        }, 500);
      });
    },
    getAudioList() {
      let searchStr = this.$route.query.searchKey ? {
        filters: [[{
          alias: 'explainObj',
          compt: "editinput",
          express: 'like',
          range: null,
          val: this.$route.query.searchKey
        }]],
        model: 0
      } : {
        filters: [[{
          alias: 'exhibitionName',
          compt: "editinput",
          express: '===',
          id: 1,
          range: null,
          val: this.exhibName
        }]],
        model: 0
      };
      let data = {
        page: this.page,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId,
        searchStr: encodeURI(JSON.stringify(searchStr)),
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(data).then(res => {
        this.total = res.totalRow;
        if (res.totalRow > 0) {
          this.loading = false;
          this.nodata = false;
          let list = this.setDatas(res.dataList, 'list');
          list = this.language ? list.filter(item => {
            return item.en_antiqueName;
          }) : list;
          // 富文本内容 只匹配标签内的内容
          list = list.map(item => {
            let str = this.language ? item.en_description : item.description;
            let regx = new RegExp("<.+?>", "g");
            str = str.replaceAll(regx, '');
            item.desc = str;
            return item;
          });
          console.log('list', list);
          if (res.totalPage === 1) {
            this.finished = true;
            this.audioList = list;
          } else {
            if (this.page === 1) {
              this.audioList = list;
            } else {
              this.audioList = this.audioList.concat(list);
              if (this.page === res.totalPage) this.finished = true;
            }
            this.page++;
          }
        } else {
          this.finished = true;
          this.nodata = true;
        }
      });
    },
    toggleFold() {
      this.isFolded = !this.isFolded;
    },
    setDatas(data, type) {
      return data.map(item => {
        return type == 'list' ? {
          exhibitionName: this.getFormData(item, 'exhibitionName', 'val'),
          antiqueName: this.getFormData(item, 'explainObj', 'val'),
          littleImage: this.getFormData(item, 'image', 'fileUrl'),
          exhibitionLocation: this.language ? this.detail.en_location : this.detail.exhibitionLocation,
          code: this.getFormData(item, 'autoCode', 'val'),
          audioPath: !this.language ? this.getFormData(item, 'audio', 'objectId') : this.getFormData(item, 'en_audio', 'objectId'),
          description: this.getFormData(item, 'introduction', 'val'),
          en_antiqueName: this.getFormData(item, 'en_explainObj', 'val'),
          en_description: this.getFormData(item, 'en_introduction', 'val')
        } : {
          exhibName: this.getFormData(item, 'name', 'val'),
          price: this.getFormData(item, 'expend', 'val'),
          exhibType: this.getFormData(item, 'type', 'val'),
          images: this.getFormData(item, 'image', 'fileUrl'),
          exhibitionLocation: this.getFormData(item, 'address', 'val'),
          exhibBegin: this.getFormData(item, 'startTime', 'val'),
          exhibEnd: this.getFormData(item, 'endTime', 'val'),
          description: this.getFormData(item, 'description', 'val'),
          en_name: this.getFormData(item, 'en_name', 'val'),
          en_location: this.getFormData(item, 'en_location', 'val'),
          en_desc: this.getFormData(item, 'en_desc', 'val')
        };
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      return target.values.length && target.values[0] ? target.values[0][0] ? Tkey === 'image' ? target.values[0][0] : target.values[0][0][key] : '' : '';
    },
    getImg(data, width, height) {
      return setImgsize(data, width, height);
    },
    onLoad() {
      if (this.$route.query.searchKey) {
        this.getAudioList();
      } else {
        this.page > 1 ? this.getAudioList() : this.getIdDetail();
      }
    }
  },
  mounted() {
    flexible();
    let query = this.$route.query;
    this.formData = {
      exhibition_formId: 171924,
      audio_formId: 171925,
      fid: query.fid
    };
    if (query.fid == 247145 && query.formId == 2544640) {
      //普陀文化馆的第二个语音导览
      this.formData = {
        exhibition_formId: 2544637,
        audio_formId: 2544640,
        fid: query.fid
      };
    }
    this.exhibCode = query.exhibCode;
    this.language = this.$route.query.language;
  },
  watch: {
    '$route'(to, from) {
      console.log(to, 'to');
      if (to.name == "audios") {
        location.reload();
      }
    }
  }
};